export default __webpack_public_path__ + "static/media/Ballroll_00064.191f6893.png";